import React from 'react';
import { useNavigate } from 'react-router-dom';
import Navbar from '@/components/Navbar';
import { Button } from '@/components/ui/button';

const Home = () => {
  const navigate = useNavigate();

  return (
    <div className="min-h-screen">
      <Navbar />
      
      {/* Hero Section */}
      <section className="relative h-screen flex items-center justify-center overflow-hidden">
        <div className="absolute inset-0">
          <img 
            src="https://images.unsplash.com/photo-1726412362671-3f18239d17bd?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDk1ODB8MHwxfHNlYXJjaHwxfHxmbHVpZCUyMGFydHxlbnwwfHx8fDE3NjEyNDgzOTd8MA&ixlib=rb-4.1.0&q=85"
            alt="Fluid Art"
            className="w-full h-full object-cover"
          />
          <div className="absolute inset-0 bg-gradient-to-b from-black/50 via-transparent to-black/70"></div>
        </div>
        
        <div className="relative z-10 text-center text-white px-4" data-testid="hero-section">
          <h1 className="text-5xl sm:text-6xl lg:text-7xl font-bold mb-6">
            Pour Decisions Never Looked This Great
          </h1>
          <p className="text-lg sm:text-xl mb-8 max-w-2xl mx-auto opacity-90">
            Explore stunning fluid art, abstract paintings, and fine art photography
          </p>
          <Button 
            size="lg" 
            className="bg-gradient-to-r from-teal-500 to-pink-500 hover:from-teal-600 hover:to-pink-600 text-white px-8 py-6 text-lg rounded-full"
            onClick={() => navigate('/shop')}
            data-testid="shop-now-btn"
          >
            Shop Now
          </Button>
        </div>
      </section>

      {/* Featured Categories */}
      <section className="py-20 px-4 bg-white">
        <div className="max-w-7xl mx-auto">
          <h2 className="text-4xl font-bold text-center mb-12 bg-gradient-to-r from-teal-500 to-pink-500 bg-clip-text text-transparent">
            Explore Our Collections
          </h2>
          
          <div className="grid md:grid-cols-3 gap-8" data-testid="categories-grid">
            <div 
              className="group cursor-pointer relative overflow-hidden rounded-2xl h-80 transition-transform hover:scale-105"
              onClick={() => navigate('/shop?category=fluid_art')}
              data-testid="category-fluid-art"
            >
              <img 
                src="https://images.unsplash.com/photo-1605557202138-097824c36ed2?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDk1ODB8MHwxfHNlYXJjaHwyfHxmbHVpZCUyMGFydHxlbnwwfHx8fDE3NjEyNDgzOTd8MA&ixlib=rb-4.1.0&q=85"
                alt="Fluid Art"
                className="w-full h-full object-cover"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-black/70 to-transparent flex items-end p-6">
                <h3 className="text-white text-2xl font-bold">Fluid Art</h3>
              </div>
            </div>
            
            <div 
              className="group cursor-pointer relative overflow-hidden rounded-2xl h-80 transition-transform hover:scale-105"
              onClick={() => navigate('/shop?category=photography_prints')}
              data-testid="category-photography"
            >
              <img 
                src="https://images.unsplash.com/photo-1610621062045-ef5f7201bb3f?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2NzF8MHwxfHNlYXJjaHwxfHxmaW5lJTIwYXJ0JTIwcGhvdG9ncmFwaHl8ZW58MHx8fHwxNzYxMjQ4NDE1fDA&ixlib=rb-4.1.0&q=85"
                alt="Photography Prints"
                className="w-full h-full object-cover"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-black/70 to-transparent flex items-end p-6">
                <h3 className="text-white text-2xl font-bold">Photography Prints</h3>
              </div>
            </div>
            
            <div 
              className="group cursor-pointer relative overflow-hidden rounded-2xl h-80 transition-transform hover:scale-105"
              onClick={() => navigate('/contact')}
              data-testid="category-custom"
            >
              <img 
                src="https://images.unsplash.com/photo-1636690581110-a512fed05fd3?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDk1ODB8MHwxfHNlYXJjaHw0fHxmbHVpZCUyMGFydHxlbnwwfHx8fDE3NjEyNDgzOTd8MA&ixlib=rb-4.1.0&q=85"
                alt="Custom Commissions"
                className="w-full h-full object-cover"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-black/70 to-transparent flex items-end p-6">
                <h3 className="text-white text-2xl font-bold">Custom Commissions</h3>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Footer */}
      <footer className="bg-gray-900 text-white py-12 px-4">
        <div className="max-w-7xl mx-auto text-center">
          <h3 className="text-3xl font-bold mb-4 bg-gradient-to-r from-teal-400 to-pink-400 bg-clip-text text-transparent">
            Fluid Fusion AZ
          </h3>
          <p className="text-gray-400 mb-4">Pour Decisions Never Looked This Great</p>
          <div className="flex flex-col items-center gap-2 mb-4">
            <a href="mailto:Azart@Fluidfusionaz.com" className="text-teal-400 hover:text-teal-300 transition-colors">
              Azart@Fluidfusionaz.com
            </a>
            <a href="tel:4807446639" className="text-teal-400 hover:text-teal-300 transition-colors">
              (480) 744-6639
            </a>
          </div>
          <p className="text-sm text-gray-500">&copy; 2025 Fluid Fusion AZ. All rights reserved.</p>
        </div>
      </footer>
    </div>
  );
};

export default Home;